import { useQuery } from '@tanstack/react-query';

import { getServiceStatus } from '../../services';

export const useGetServiceStatus = () => {
  return useQuery({
    queryKey: ['get_service_status'],
    queryFn: getServiceStatus,
  });
};
